<!--
  Generated template for the ModalPatientTabsPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>
    <ion-toolbar>
        <ion-title>{{showPatient ? "" : "offener Fall"}} {{patientDataProvider.activePatientData.addressData.firstname}} {{patientDataProvider.activePatientData.addressData.lastname}}</ion-title>
        <ion-buttons slot="primary">
            <ion-button color="primary" (click)="dismiss()">
                {{ 'CLOSE_BUTTON' | translate }}
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<ion-content>
    <details-tab-card #detailsTabCard [tabsAlertData]="patientAlertProvider.activeAlertData" [tabsRootData]="patientDataProvider.activePatientData"
                      dataType="patient"></details-tab-card>
    <phone-call-panel *ngIf="isCore" [address]="{test:1}"></phone-call-panel>
</ion-content>
